import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import axios from 'axios';

function HomePage() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleJoinWaitlist = async () => {
    if (!email.trim()) {
      setMessage({ type: 'error', text: '請輸入 Email 地址' });
      return;
    }

    try {
      setIsSubmitting(true);
      setMessage({ type: '', text: '' });

      const response = await axios.post('/api/waitlist', { email });

      if (response.data.success) {
        setMessage({ type: 'success', text: response.data.message });
        setEmail(''); // 清空輸入

        // 如果用戶已註冊，3秒後導向登入頁
        if (response.data.alreadyRegistered) {
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      }
    } catch (error) {
      console.error('加入等候清單失敗:', error);
      const errorMsg = error.response?.data?.message || '加入失敗，請稍後再試';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleJoinWaitlist();
    }
  };

  useEffect(() => {
    // TODO: Implement language detection
    window.location.href = "/go/zh-tw";
  });

  return <></>;
  return (
    <div style={{
      minHeight: '100vh',
      background: '#000000',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <Navigation />

      {/* Hero Section */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 6rem) clamp(1rem, 5vw, 5%)',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Gradient Orbs */}
        <div style={{
          position: 'absolute',
          top: '-10%',
          left: '-10%',
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(135, 207, 235, 0.3) 0%, transparent 70%)',
          filter: 'blur(80px)',
          pointerEvents: 'none',
          zIndex: 0
        }} />
        <div style={{
          position: 'absolute',
          top: '-5%',
          right: '15%',
          width: '500px',
          height: '500px',
          background: 'radial-gradient(circle, rgba(135, 206, 235, 0.2) 0%, transparent 70%)',
          filter: 'blur(80px)',
          pointerEvents: 'none',
          zIndex: 0
        }} />

        {/* New Badge */}
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.75rem',
          background: 'rgba(135, 206, 235, 0.1)',
          border: '1px solid rgba(135, 206, 235, 0.3)',
          borderRadius: '50px',
          padding: '0.5rem 1.5rem',
          marginBottom: '2rem',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          position: 'relative',
          zIndex: 1,
          backdropFilter: 'blur(10px)'
        }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(135, 206, 235, 0.15)';
            e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.5)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(135, 206, 235, 0.1)';
            e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.3)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <span style={{
            background: 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
            color: 'white',
            fontSize: 'var(--font-xxxs)',
            fontWeight: '700',
            padding: '0.25rem 0.75rem',
            borderRadius: '20px'
          }}>
            New
          </span>
          <span style={{
            color: 'rgba(255, 255, 255, 0.9)',
            fontSize: 'var(--font-xxs)',
            fontWeight: '500'
          }}>
            推出 AI 內容模板生成器
          </span>
          <Icon icon="mdi:arrow-right" width="18" style={{ color: 'rgba(255, 255, 255, 0.7)' }} />
        </div>

        {/* Main Heading */}
        <h1 style={{
          fontSize: 'var(--font-5xl)',
          fontWeight: '800',
          marginBottom: '1.5rem',
          lineHeight: '1.1',
          letterSpacing: '-0.02em',
          position: 'relative',
          zIndex: 1,
          background: 'linear-gradient(135deg, #ffffff 0%, #87CEEB 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          The AI Agent
          <br />
          for Social Media
        </h1>

        <p style={{
          fontSize: 'var(--font-sm)',
          color: 'rgba(255, 255, 255, 0.7)',
          marginBottom: 'clamp(2.5rem, 5vw, 3.5rem)',
          maxWidth: '700px',
          margin: '0 auto clamp(2.5rem, 5vw, 3.5rem) auto',
          lineHeight: '1.6',
          position: 'relative',
          zIndex: 1
        }}>
          用 AI 自動化你的社群經營
        </p>

        {/* Search Bar Style CTA */}
        <div style={{
          maxWidth: '700px',
          margin: '0 auto',
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(20px)',
          borderRadius: '16px',
          padding: '0.5rem',
          border: '1px solid rgba(135, 206, 235, 0.2)',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          boxShadow: '0 8px 32px rgba(135, 206, 235, 0.1)',
          transition: 'all 0.3s ease',
          position: 'relative',
          zIndex: 1
        }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.4)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(135, 206, 235, 0.2)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.2)';
            e.currentTarget.style.boxShadow = '0 8px 32px rgba(135, 206, 235, 0.1)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <Icon icon="mdi:account-circle" width="24" style={{ color: 'rgba(255, 255, 255, 0.5)', flexShrink: 0, marginLeft: '0.5rem' }} />
          <input
            type="email"
            placeholder="輸入Email加入等候清單....."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isSubmitting}
            style={{
              flex: 1,
              background: 'transparent',
              border: 'none',
              outline: 'none',
              color: 'white',
              fontSize: 'var(--font-xs)',
              fontFamily: 'inherit',
              minWidth: 0,
              opacity: isSubmitting ? 0.6 : 1
            }}
            onFocus={(e) => e.target.placeholder = ''}
            onBlur={(e) => e.target.placeholder = '輸入Email加入等候清單.....'}
          />

          <button
            onClick={handleJoinWaitlist}
            disabled={isSubmitting}
            style={{
              background: 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
              color: 'white',
              border: 'none',
              padding: isMobile ? '0.65rem' : '0.65rem 1.75rem',
              borderRadius: isMobile ? '50%' : '10px',
              fontSize: 'var(--font-xs)',
              fontWeight: '600',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              flexShrink: 0,
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap',
              boxShadow: '0 4px 12px rgba(135, 206, 235, 0.4)',
              width: isMobile ? '40px' : 'auto',
              height: isMobile ? '40px' : 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: isSubmitting ? 0.6 : 1
            }}
            onMouseEnter={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(135, 206, 235, 0.5)';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(135, 206, 235, 0.4)';
            }}
          >
            {isSubmitting ? (
              <Icon icon="line-md:loading-loop" width="20" />
            ) : isMobile ? (
              <Icon icon="mdi:arrow-right" width="20" />
            ) : (
              '加入'
            )}
          </button>
        </div>

        {/* Success/Error Message */}
        {message.text && (
          <div style={{
            marginTop: '1rem',
            padding: '1rem',
            borderRadius: '12px',
            background: message.type === 'success'
              ? 'rgba(16, 185, 129, 0.1)'
              : 'rgba(239, 68, 68, 0.1)',
            border: `1px solid ${message.type === 'success' ? 'rgba(16, 185, 129, 0.3)' : 'rgba(239, 68, 68, 0.3)'}`,
            color: message.type === 'success' ? '#10b981' : '#ef4444',
            textAlign: 'center',
            fontSize: 'var(--font-xs)',
            fontWeight: '500',
            maxWidth: '700px',
            margin: '1rem auto 0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            position: 'relative',
            zIndex: 1
          }}>
            <Icon
              icon={message.type === 'success' ? 'mdi:check-circle' : 'mdi:alert-circle'}
              width="20"
            />
            {message.text}
          </div>
        )}

        {/* Demo Video */}
        <div style={{
          marginTop: 'clamp(3rem, 6vw, 5rem)',
          maxWidth: '1200px',
          margin: 'clamp(3rem, 6vw, 5rem) auto 0 auto',
          borderRadius: 'clamp(12px, 3vw, 20px)',
          background: "rgba(26, 26, 46, 0.6)",
          border: '1px solid rgba(255,255,255,0.1)',
          padding: 'clamp(1rem, 3vw, 2rem)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
        }}>
          <video
            controls
            style={{
              width: '100%',
              aspectRatio: '16 / 9',
              borderRadius: 'clamp(8px, 2vw, 16px)',
              objectFit: 'cover',
              display: 'block',
              backgroundColor: 'rgba(0, 0, 0, 0.3)'
            }}
            poster={require('../../assets/image/new-landing-video-poster.jpg')}
          >
            <source src={require('../../assets/video/landing-page-video.mov')} type="video/mp4" />
            <source src="/videos/demo-video.webm" type="video/webm" />
            您的瀏覽器不支援影片播放。
          </video>
        </div>
      </section>

      {/* Problem Section */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: 'rgba(30, 30, 46, 0.5)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div>
          <h2 style={{
            fontSize: 'var(--font-3xl)',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
          }}>
            2026 年，90% 網路內容將由 AI 產生。您準備好了嗎？
          </h2>

          <p style={{
            textAlign: 'center',
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 'var(--font-xs)',
            marginBottom: 'clamp(2rem, 4vw, 3rem)',
            maxWidth: '700px',
            margin: '0 auto clamp(2rem, 4vw, 3rem) auto'
          }}>
            許多品牌與創作者正面臨內容產出的挑戰，導致錯失成長機會。
          </p>

          <ul style={{
            listStyle: 'none',
            padding: 0,
            maxWidth: '800px',
            margin: '0 auto clamp(2rem, 4vw, 3rem) auto'
          }}>
            {[
              "產能瓶頸：即使團隊全力以赴，一天也難以產出上百則測試稿，限制了 A/B 測試與規模化。",
              "成本高漲：外包與人力費用持續上升，卻無法保證爆款內容，導致 ROI 低下。",
              "品牌不一致：多手作業容易造成語氣、調性偏差，損害品牌形象與信任。",
              "時間延遲：從靈感到發佈需數小時或天，錯過社群趨勢與即時互動機會。"
            ].map((bullet, index) => (
              <li key={index} style={{
                marginBottom: '1rem',
                padding: '1rem',
                background: 'rgba(135, 206, 235, 0.05)',
                borderRadius: '12px',
                borderLeft: '3px solid #87CEEB',
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: 'var(--font-xs)'
              }}>
                {bullet}
              </li>
            ))}
          </ul>

          <p style={{
            textAlign: 'center',
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 'var(--font-xs)',
            maxWidth: '700px',
            margin: '0 auto'
          }}>
            內容創作已進入「系統化」時代——不是更努力，而是更聰明。ViralArc.ai 幫助您從這些痛點中解放，實現高效、一致的內容策略。
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(135, 206, 235, 0.05) 50%, rgba(0, 0, 0, 0) 100%)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Gradient Orb */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(135, 206, 235, 0.15) 0%, transparent 70%)',
          filter: 'blur(100px)',
          pointerEvents: 'none',
          zIndex: 0
        }} />
        <h2 style={{
          fontSize: 'var(--font-3xl)',
          fontWeight: '700',
          marginBottom: 'clamp(0.5rem, 2vw, 1rem)',
          position: 'relative',
          zIndex: 1
        }}>
          準備好用 AI 改變你的社群經營了嗎？
        </h2>
        <p style={{
          fontSize: 'var(--font-xs)',
          color: 'rgba(255, 255, 255, 0.7)',
          marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
          position: 'relative',
          zIndex: 1
        }}>
          加入超過 100+ 品牌，開始自動化社群經營
        </p>
        <button
          onClick={() => navigate('/register')}
          style={{
            background: 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
            border: 'none',
            color: 'white',
            padding: 'clamp(0.75rem, 2vw, 1rem) clamp(2rem, 5vw, 3rem)',
            borderRadius: '12px',
            fontSize: 'var(--font-xs)',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 8px 24px rgba(135, 206, 235, 0.4)',
            transition: 'all 0.3s ease',
            position: 'relative',
            zIndex: 1
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-4px)';
            e.target.style.boxShadow = '0 16px 32px rgba(135, 206, 235, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 8px 24px rgba(135, 206, 235, 0.4)';
          }}
        >
          免費試用 7 天
        </button>
      </section>

      <Footer />
    </div>
  );
}

export default HomePage;
